//--------------------------------------------------
//
//  Controller
//
//--------------------------------------------------

import Base from "@/js/_MyLibs/Util/Base";
import gsap from "gsap";
import $ from "jquery";
import { UAParser } from "ua-parser-js";

export default class Controller extends Base {
  constructor() {
    super();

    this.name = "FixedBottomBtn";

    this.$wrap = $(".js-fixedBottomBtn");

    this.isSEv = true;
    this.isShow = false;

    this.setup();
    this.setEvents();
  }

  setup() {}

  show() {
    this.isShow = true;
    const tl = gsap.timeline();

    tl.to(this.$wrap, 1, {
      y: 0,
      ease: "expo.out"
    });
  }

  hide() {
    const tl = gsap.timeline();

    tl.to(this.$wrap, 1, {
      y: "110%",
      ease: "expo.out",
      onComplete: () => {
        this.isShow = false;
      }
    });
  }

  onScroll() {
    const st = window.pageYOffset;

    if (st >= window.innerHeight) {
      if (this.isShow) return;
      this.show();
    } else {
      if (!this.isShow) return;
      this.hide();
    }
  }

  update() {}

  onResize() {}

  setEvents() {
    super.setEvents();
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/compornent/FixedBottomBtn/Controller.es6
// module id = null
// module chunks = 